<template>
  <zt-modal :active="confirmModalActive" @close="closeModal" max-width="42rem" :z-index="200" :fullscreen="isMobile">
    <template slot="modal-header">
      <div class="p-4 font-normal text-zt-lg text-center md:text-left">
        {{ $t('message.linkUser.cancelLinkUserModal.modalTitle') }}
      </div>
    </template>
    <div class="p-10 text-center md:flex md:text-left">
      <div class="md:w-1/4">
        <zt-icon name="exclamation-circle-outline" class="text-zt-warning" :style="{ fontSize: '6rem' }"></zt-icon>
      </div>
      <div class="md:w-3/4">
        <h1 class="text-bold text-xl mb-4  md:mb-3">
          {{ $t("message.settingsComponent.linkEmailAccount") }}
        </h1>
        <div class="text-left">
          <p class=" text-zt-dark-500">{{ $t("message.settingsComponent.confirmAccion") }}</p>
        </div>
      </div>
    </div>
    <div
      class="zt-modal-footer grey-background border-b flex p-5 fixed md:relative bottom-0 right-0 left-0 justify-end">
      <div class="">
        <zt-button data-vs-button="active-step" class="ml-1 w-11/12" color="disabled" style="color: #707070 !important"
          @click="closeModal()">{{ $t('message.linkUser.cancelLinkUserModal.cancelButton') }}</zt-button>
      </div>
      <div class="">
        <zt-button data-vs-button="active-step" class="ml-1 w-11/12" @click="confirmCancel()">{{
          $t("message.homeComponent.linkUserLogin.byEmail.ok") }}</zt-button>
      </div>
    </div>
  </zt-modal>

</template>

<script>
export default {
  name: 'Confirm',
  props: {
    isMobile: {
      type: Boolean,
      default: false
    },
    confirmModalActive: {
      type: Boolean,
      default: false
    },
  },
  methods: {
    confirmCancel() {
      this.closeModal()
      this.$router.push({ path: '/' })
    },
    closeModal() {
      this.$emit('update:confirmModalActive', false);
    },
  }
}
</script>
<style scoped>
.grey-background {
  background-color: #ebebeb;
}
</style>